export default {
  SET_DATA_SUB_KAT (state, data) {
    state.sub_kategori_sos = data
  },
  SET_DATA_KAT(state, data) {
  	state.kategori_sos = data
  }
}